module.exports = __webpack_public_path__ + "img/slider-bg-2.e0a775c1.svg";